//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import SideColumn from './SideColumn';
import TipoOrcamentoTabela from './TipoOrcamentoTabela';

import { copyObject } from '../../../../common/functions/helpers';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'TipoOrcamento',
  extends: CRUDGenerico,
  data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      tipoOrcamentoResources: this.$api.tipoOrcamento(this.$resource),
      tableHeader: [
        {
          name: this.$t('label.codigo'),
          tooltip: this.$t('label.cod_tipo_orcamento'),
          sortType: 'idExterno',
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.nome'),
          tooltip: this.$t('label.nome_tipo_orcamento'),
          sortType: 'descricao',
          classes: [],
        },
        {
          name: this.$tc('label.tipo_investimento', 2),
          tooltip: this.$t('label.tipo_investimento_tipo_orcamento'),
          sortType: 'tiposInvestimento',
          classes: ['md-hide-medium'],
        },
      ],
      tableRows: [],
    };
  },
  computed: {
    ...generateComputed('Tipo Orc', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  components: {
    SideColumn,
    TipoOrcamentoTabela,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    requestAdicionar(objeto, cb = null) {
      const payload = copyObject(objeto);
      payload.tiposInvestimento = objeto.tiposInvestimento.map(el => el.id);

      this.tipoOrcamentoResources.gravar(payload)
        .then((docs) => {
          objeto.id = docs.data.id;
          this.tableRows.unshift(objeto);
          this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestAtivarInativar(index) {
      const row = this.tableRows[index],
        id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.tipoOrcamentoResources);
    },
    requestAtualizar(objeto) {
      const payload = Object.assign({}, objeto);

      payload.tiposInvestimento = objeto.tiposInvestimento.map(el => el.id);

      delete payload.dependencias;

      this.tipoOrcamentoResources.atualizar(payload)
        .then(() => {
          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          this.atualizar(objeto);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestExportacao(cb) {
      this.exportar(cb, 'tipo_orcamento_simples');
    },
    requestPopular(page = null, cb = null) {
      this.requestPopularGenerico(this.tipoOrcamentoResources.listar, page, cb);
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-orcamento/TipoOrcamento.vue?vue&type=script&lang=js&